module.exports = __webpack_public_path__ + "img/soltix-ar-badge.7b784d44.svg";